import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { useMutationCallback } from 'shared/api/hooks';
import { InsertEmoticon, SentimentSatisfied, SentimentVeryDissatisfied, } from '@mui/icons-material';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { Alert, Fade, LinearProgress, List, ListItemButton, ListItemIcon, ListItemText, } from '@mui/material';
import { CustomIcon } from 'shared/components/icon/custom';
import { getRateTranslate } from 'features/support.chat/utils';
import { useNavigateRoot } from 'shared/hooks/router';
export const useRateDialog = (ticket_id, token) => {
    const [opened, close, open] = useBooleanState(false);
    const RateDialog = useMemo(() => {
        const RateDialogComponent = ({ children, ...rest }) => {
            const [onConfirm, loading, response, error] = useMutationCallback('support/rate_issue');
            const _onConfirm = useCallback((rate) => () => {
                if (ticket_id != null && token != null) {
                    onConfirm({ rate, ticket_id, token });
                }
            }, [ticket_id, token]);
            const navigateToRoot = useNavigateRoot();
            useEffect(() => {
                if (response != null && error == null) {
                    close();
                    setTimeout(() => {
                        navigateToRoot();
                    }, 500);
                }
            }, [response, error]);
            const rates = useMemo(() => [
                ['good', InsertEmoticon, 'success'],
                ['normal', SentimentSatisfied, undefined],
                ['bad', SentimentVeryDissatisfied, 'error'],
            ], []);
            return (_jsxs(MessageBox, { open: opened, onClose: close, isInfo: true, title: "\u041E\u0446\u0435\u043D\u0438\u0442\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u0437\u0430\u044F\u0432\u043A\u0438", ...rest, children: [_jsx(Fade, { in: loading, children: _jsx(LinearProgress, { sx: { mb: 2 } }) }), error && _jsx(Alert, { severity: "error", children: error }), _jsx(List, { children: rates.map(([rate, icon, color]) => (_jsxs(ListItemButton, { onClick: _onConfirm(rate), children: [_jsx(ListItemIcon, { children: _jsx(CustomIcon, { Icon: icon, fontSize: "3em", 
                                        //@ts-ignore
                                        color: color }) }), _jsx(ListItemText, { primary: getRateTranslate(rate).toUpperCase() })] }, rate))) }), children] }));
        };
        return RateDialogComponent;
    }, [opened, close, ticket_id]);
    return [RateDialog, open];
};
